import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/static/Header';
import VenuePage from './pages/VenuePage';
import TravelPage from './pages/TravelPage';
import AccommodationPage from './pages/AccommodationPage';
import CoChairsPage from './pages/CoChairsPage';
import LocalOrganizingCommitteePage from './pages/LocalOrganizingCommitteePage';
import InternationalOrganizingCommitteePage from './pages/InternationalOrganizingCommitteePage';
import InternationalAdvisoryCommitteePage from './pages/InternationalAdvisoryCommitteePage';
import InternationalScientificCommitteePage from './pages/InternationalScientificCommitteePage';
import InternationalECRCommitteePage from './pages/InternationalECRCommitteePage';
import RegistrationPage from './pages/RegistrationPage';
import ProgramPage from './pages/ProgramPage';
import TemplatesPage from './pages/TemplatesPage';
import MSSSRegistrationPage from './pages/MSSSRegistrationPage';
import PrizeBestPaperPage from './pages/PrizeBestPaperPage';
import BestPaperPage from './pages/BestPaperPage';
import CreditsPage from './pages/CreditsPage';
import Footer from './components/static/Footer';
import AnnouncementBar from './components/static/AnnouncementBar';
import ScrollToTop from './components/static/ScrollToTop';
// import PlaceholderPage from './pages/PlaceholderPage';
import PlenarySpeakersPage from './pages/PlenarySpeakersPage';
import KeynoteSpeakersPage from './pages/KeynoteSpeakersPage';
import EICForumPage from './pages/EICForumPage';
import NotFoundPage from './pages/NotFoundPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import SponsorsPage from './pages/SponsorsPage';
import HomePage from './pages/HomePage';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <header>
          <AnnouncementBar />
          <Header />
        </header>

        <main>
          <Routes>
            <Route path="/" element={
              <HomePage />
            } />

            <Route path="/speakers/plenary" element={<PlenarySpeakersPage />} />
            <Route path="/speakers/keynote" element={<KeynoteSpeakersPage />} />
            <Route path="/speakers/eic-forum" element={<EICForumPage />} />

            <Route path="/committees/co-chairs" element={<CoChairsPage />} />
            <Route path="/committees/local-organizing" element={<LocalOrganizingCommitteePage />} />
            <Route path="/committees/international-organizing" element={<InternationalOrganizingCommitteePage />} />
            <Route path="/committees/international-advisory" element={<InternationalAdvisoryCommitteePage />} />
            <Route path="/committees/international-scientific" element={<InternationalScientificCommitteePage />} />
            <Route path="/committees/international-ecr" element={<InternationalECRCommitteePage />} />

            <Route path="/travel/info" element={<TravelPage />} />
            <Route path="/travel/accommodation" element={<AccommodationPage />} />

            <Route path="/venue" element={<VenuePage />} />
            <Route path="/information/program" element={<ProgramPage />} />
            <Route path="/information/templates" element={<TemplatesPage />} />
            <Route path="/information/ms-ss-registration" element={<MSSSRegistrationPage />} />
            <Route path="/information/prize" element={<PrizeBestPaperPage />} />
            <Route path="/information/best-paper" element={<BestPaperPage />} />
            <Route path="/registration" element={<RegistrationPage />} />
            <Route path="/announcements" element={<AnnouncementsPage />} />
            <Route path="/sponsors" element={<SponsorsPage />} />

            {/* Hidden credits route */}
            <Route path="/credits" element={<CreditsPage />} />

            {/* Catch-all 404 route */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <footer>
          <Footer />
        </footer>
      </div>
    </Router>
  );
}

export default App;
